/* eslint-disable */
const routes = [
  // LOGIN FORM
  {
    path: "/",
    name: "Login-Layout",
    component: () => import("src/components/auth/AuthLayout.vue"),
    meta: {
      allowAnonymous: true
    }
  },
  //MAIN APP
  {
    path: "/",
    component: () => import("src/components/core/MainLayout.vue"),
    meta: { requiresAuth: true },
    children: [
      // Page Routes
      {
        path: "/dashboard",
        name: "Dashboard",
        component: () => import("../pages/bp-dashboard/base-dashboard.vue"),
        meta: {
          breadcrumb: [{ name: "Dashboard" }],
          requiresAuth: true
        }
      },
      {
        path: "/company-chart",
        name: "CompanyChart",
        component: () =>
          import("../pages/bp-organization-chart/base-company-chart.vue"),
        meta: {
          breadcrumb: [{ name: "CompanyChart" }],
          requiresAuth: true
        }
      },
      //route for profile
      {
        path: "/profile",
        name: "Profile",
        component: () => import("../pages/bp-my-profile/base-profile.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //CEO Pages
      {
        path: "/timeattendance",
        name: "ceo-time-attendance",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-time-attendance.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceocalendar",
        name: "ceo-calendar",
        component: () => import("../pages/bp-ceo-pages/base-ceo-calendar.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceoemployeelist",
        name: "ceoEmployeeList",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-employee-list.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceoemployeeprofile/:id",
        name: "ceo-employee-profile",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-employee-profile.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceovaluationlist",
        name: "ceo-evaluation-list",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-evaluation-list.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceovaluationdetails/:id/:employee_id",
        name: "ceo-evaluation-details",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-evaluation-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceovaluationreview/:id/:employee_id",
        name: "ceo-evaluation-review",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-evaluation-review.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceoleaverequest",
        name: "ceoleaverequest",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-leave-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceoapproveleave/:id",
        name: "ceoApproveLeave",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-approve-leave.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceonterequest",
        name: "ceoNteRequest",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-nte-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceocoachingtecord",
        name: "ceoCoachingRecord",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-coaching-record.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/nteViewTracker/:id/:employeeId",
        name: "ceo-view-nte-tracker",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-view-nte-tracker.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceoNteApproval/:id/:employeeId",
        name: "ceo-nte-approval",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-nte-approval.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/ceoCoachingDetails/:coachId",
        name: "ceo-coaching-details",
        component: () =>
          import("../pages/bp-ceo-pages/base-ceo-coaching-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for Employee Request
      {
        path: "/employeerequest",
        name: "employeerequest",
        component: () =>
          import("../pages/bp-employee-request/base-employee-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeeleavedetails/:id",
        name: "employee-leave-details",
        component: () =>
          import("../pages/bp-employee-request/base-employee-leave-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/editemployeerequest/:id",
        name: "editemployeerequest",
        component: () =>
          import("../pages/bp-employee-request/base-employee-edit-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeescheduleadjustment",
        name: "employee-schedule-adjustment",
        component: () =>
          import("../pages/bp-employee-request/base-employee-schedule-adjustment.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/EmployeeEditScheduleAdjustment",
        name: "employee-edit-schedule-adjustment",
        component: () =>
          import("../pages/bp-employee-request/base-employee-edit-schedule-adjustment.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeeundertimerequest",
        name: "employee-undertime-request",
        component: () =>
          import("../pages/bp-employee-request/base-employee-undertime-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeeeditundertimerequest",
        name: "employee-edit-undertime-request",
        component: () =>
          import("../pages/bp-employee-request/base-employee-edit-undertime-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //Members List
      {
        path: "/memberslist",
        name: "members-list",
        component: () => import("../pages/bp-members-list/base-members.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/membersprofile/:id",
        name: "members-view-profile",
        component: () =>
          import("../pages/bp-members-list/base-member-profile.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //Employee List
      {
        path: "/employeelist",
        name: "employee-list",
        component: () => import("../pages/bp-employee-list/base-employees.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeeprofile/:id",
        name: "employee-view-profile",
        component: () =>
          import("../pages/bp-employee-list/base-employee-profile.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for member request
      {
        path: "/memberleavedetails/:id",
        name: "member-leave-details",
        component: () =>
          import("../pages/bp-member-request/base-member-leave-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/memberleaverequest",
        name: "memberleaverequest",
        component: () =>
          import("../pages/bp-member-request/base-member-leave-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/editmemberleaverequest/:id",
        name: "editmemberleaverequest",
        component: () =>
          import("../pages/bp-member-request/base-member-edit-leave-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/memberundertimerequest",
        name: "member-undertime-request",
        component: () =>
          import("../pages/bp-member-request/base-member-undertime-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/membereditundertimerequest",
        name: "member-edit-undertime-request",
        component: () =>
          import("../pages/bp-member-request/base-member-edit-undertime-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/memberdscheduleadjustmentrequest",
        name: "member-schedule-adjustment-request",
        component: () =>
          import("../pages/bp-member-request/base-member-adjustment-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/membereditscheduleadjustmentrequest",
        name: "member-edit-schedule-adjustment-request",
        component: () =>
          import("../pages/bp-member-request/base-member-edit-adjustment-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for reminders
      {
        path: "/reminders",
        name: "reminders",
        component: () => import("../pages/bp-my-reminders/base-reminders.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for leave request
      {
        path: "/leaverequest",
        name: "leaverequest",
        component: () =>
          import("../pages/bp-my-leave-request/base-leave-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/newleaverequest",
        name: "newleaverequest",
        component: () =>
          import("../pages/bp-my-leave-request/base-new-leave-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/updaterequest",
        name: "updaterequest",
        component: () =>
          import("../pages/bp-my-leave-request/base-edit-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/viewrequest",
        name: "viewrequest",
        component: () =>
          import("../pages/bp-my-leave-request/base-view-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for undertime request
      {
        path: "/undertimerequest",
        name: "undertimerequest",
        component: () =>
          import("../pages/bp-my-undertime-request/base-undertime-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/newundertimerequest",
        name: "newundertimerequest",
        component: () =>
          import("../pages/bp-my-undertime-request/base-new-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/editundertimerequest",
        name: "edit-under-time-request",
        component: () =>
          import("../pages/bp-my-undertime-request/base-edit-undertime.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for adjust schedule
      {
        path: "/adjustschedule",
        name: "adjustschedule",
        component: () =>
          import("../pages/bp-my-schedule-adjustment/base-adjustment-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/editadjustschedule",
        name: "edit-adjust-schedule",
        component: () =>
          import("../pages/bp-my-schedule-adjustment/base-edit-adjustment.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/newadjustschedule",
        name: "newadjustschedule",
        component: () =>
          import("../pages/bp-my-schedule-adjustment/base-new-adjustment.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for NTE Request - TL SIDE
      {
        path: "/nterequest",
        name: "nte-request",
        component: () =>
          import("../pages/bp-member-request/base-member-nte-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/nterequestform",
        name: "nte-request-form",
        component: () =>
          import("../pages/bp-member-request/base-member-nte-request-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/editnterequestform/:id/:employee_id",
        name: "edit-nte-request-form",
        component: () =>
          import("../pages/bp-member-request/base-member-edit-nte-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/nteviewrequestdetails/:id/:employee_id",
        name: "nte-view-request-details",
        component: () =>
          import("../pages/bp-member-request/base-member-nte-view-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      // Coaching Module BY ASM
      {
        path: "/employee/coaching/records",
        name: "employee-coaching-records",
        component: () =>
          import("../pages/bp-employee-coaching/base-employee-coaching-records.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/coaching/form",
        name: "employee-coaching-form",
        component: () =>
          import("../pages/bp-employee-coaching/base-employee-coaching-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/coaching/update/:id",
        name: "employee-coaching-update",
        component: () =>
          import("../pages/bp-employee-coaching/base-employee-coaching-update.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/coaching/details/:id/:uuid",
        name: "employee-coaching-details",
        component: () =>
          import("../pages/bp-employee-coaching/base-employee-coaching-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      // Coaching Module BY TL
      {
        path: "/member/coaching/records",
        name: "member-coaching-records",
        component: () =>
          import("../pages/bp-member-coaching/base-member-coaching-records.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/member/coachingform",
        name: "member-coaching-form",
        component: () =>
          import("../pages/bp-member-coaching/base-member-coaching-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/member/coaching/update/:id",
        name: "member-coaching-update",
        component: () =>
          import("../pages/bp-member-coaching/base-member-coaching-update.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/member/coaching/details/:id",
        name: "member-coaching-details",
        component: () =>
          import("../pages/bp-member-coaching/base-member-coaching-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //My Performance Evaluation AGENT SIDE
      {
        path: "/my/evaluation/list",
        name: "my-evaluation-list",
        component: () =>
          import("../pages/bp-my-evaluation/base-evaluation-list.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/my/evaluation/review/:id",
        name: "my-evaluation-review",
        component: () =>
          import("../pages/bp-my-evaluation/base-evaluation-review.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/my/evaluation/details/:id",
        name: "view-evaluation-details",
        component: () =>
          import("../pages/bp-my-evaluation/base-view-evaluation.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //Members Performance Evaluation -TL SIDE
      {
        path: "/members/evaluation/list",
        name: "member-evaluation-list",
        component: () =>
          import("../pages/bp-member-evaluation/base-member-evaluation-list.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/members/evaluation/details/:id/:employee_id",
        name: "member-evaluation-details",
        component: () =>
          import("../pages/bp-member-evaluation/base-member-evaluation-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/members/evaluation/form",
        name: "member-evaluation-form",
        component: () =>
          import("../pages/bp-member-evaluation/base-member-evaluation-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/members/evaluation/update/:id/:employee_id",
        name: "member-evaluation-update",
        component: () =>
          import("../pages/bp-member-evaluation/base-member-evaluation-update.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //Employees Performance Evaluation -AM SIDE
      {
        path: "/employee/evaluation/list",
        name: "employee-evaluation-list",
        component: () =>
          import("../pages/bp-employee-evaluation/base-employee-evaluation-list.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/evaluation/details/:id/:employee_id",
        name: "employee-evaluation-details",
        component: () =>
          import("../pages/bp-employee-evaluation/base-employee-evaluation-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/evaluation/form",
        name: "employee-evaluation-form",
        component: () =>
          import("../pages/bp-employee-evaluation/base-employee-evaluation-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/evaluation/update/:id/:employee_id",
        name: "employee-evaluation-update",
        component: () =>
          import("../pages/bp-employee-evaluation/base-employee-evaluation-update.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employee/evaluation/review/:id/:employee_id",
        name: "employee-evaluation-review",
        component: () =>
          import("../pages/bp-employee-evaluation/base-employee-evaluation-review.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //Coaching Module BY Member
      {
        path: "/my/coaching/records",
        name: "my-coaching-records",
        component: () =>
          import("../pages/bp-my-coaching/base-my-coaching-records.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/my/commitment/form/:id",
        name: "my-commitment-form",
        component: () =>
          import("../pages/bp-my-coaching/base-my-commitment-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/my/coaching/details/:id",
        name: "my-coaching-details",
        component: () =>
          import("../pages/bp-my-coaching/base-my-coaching-details.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/my/coaching/update/:id",
        name: "my-coaching-update",
        component: () =>
          import("../pages/bp-my-coaching/base-my-coaching-update.vue"),
        meta: {
          requiresAuth: true
        }
      },
      // Route for NTE Request - ASM Side
      {
        path: "/employeenterequest",
        name: "employee-nte-request",
        component: () =>
          import("../pages/bp-employee-request/base-employee-nte-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeenterequestform",
        name: "employee-nte-request-form",
        component: () =>
          import("../pages/bp-employee-request/base-employee-nte-request-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeeeditnterequestform/:id/:employee_id",
        name: "employee-edit-nte-request",
        component: () =>
          import("../pages/bp-employee-request/base-employee-edit-nte-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeenteapproval/:id/:employee_id",
        name: "employee-nte-approval",
        component: () =>
          import("../pages/bp-employee-request/base-employee-nte-approval.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/employeenteviewrequest/:id/:employee_id",
        name: "employee-nte-view-request",
        component: () =>
          import("../pages/bp-employee-request/base-employee-nte-view-request.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for responsibility form
      {
        path: "/responsibilityform",
        name: "responsibility-form",
        component: () =>
          import("../pages/bp-my-responsibility-form/base-responsibility-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/wfh/responsibility/form",
        name: "wfh-responsibility-form",
        component: () =>
          import("../pages/bp-my-responsibility-form/base-wfh-responsibility-form.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for documents
      {
        path: "/documents",
        name: "documents",
        component: () => import("../pages/bp-documents/base-documents.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/calendar",
        name: "calendar",
        component: () => import("../pages/bp-calendar/base-calendar.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/holidays",
        name: "holidays",
        component: () => import("../pages/bp-calendar/base-holidays.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/workschedule",
        name: "workschedule",
        component: () =>
          import("../pages/bp-work-shift/base-work-schedule.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/addworkshift",
        name: "workshift",
        component: () => import("../pages/bp-work-shift/base-work-shift.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/addrestday",
        name: "restday",
        component: () => import("../pages/bp-work-shift/base-rest-day.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/addcalendarevent",
        name: "add-calendar-event",
        component: () =>
          import("../pages/bp-calendar/base-add-calendar-event.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for time & attendance
      {
        path: "/timeattendance",
        name: "time-attendance",
        component: () =>
          import("../pages/bp-time-attendance/base-time-attendance.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/editattendance/:id",
        name: "edit-attendance",
        component: () =>
          import("../pages/bp-time-attendance/base-edit-attendance.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for contracts memo
      {
        path: "/contractsmemo",
        name: "contracts-memo",
        component: () =>
          import("../pages/bp-contracts-memo/base-contracts-memo.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for assigning contracts
      {
        path: "/contracts/assign/:id",
        name: "assign-contracts",
        component: () =>
          import("../pages/bp-contracts-memo/base-assign-contracts.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for assigning memos
      {
        path: "/memos/assign/:id",
        name: "assign-memos",
        component: () =>
          import("../pages/bp-contracts-memo/base-assign-memos.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for announcement
      {
        path: "/announcements",
        name: "announcements",
        component: () =>
          import("../pages/bp-announcement/base-announcement.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for birthday event
      {
        path: "/mycalendar",
        name: "my-calendar",
        component: () => import("../pages/bp-my-calendar/base-my-calendar.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for calendar event
      {
        path: "/calendarEvent",
        name: "calendar-event",
        component: () =>
          import("../pages/bp-my-calendar/base-calendar-event.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for attendance
      {
        path: "/attendance",
        name: "attendance",
        component: () => import("../pages/bp-attendance/base-attendance.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for reports
      {
        path: "/reports",
        name: "reports",
        component: () => import("../pages/bp-my-reports/base-reports.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/updatereport",
        name: "update-report",
        component: () =>
          import("../pages/bp-my-reports/base-update-report.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/viewreport",
        name: "view-report",
        component: () => import("../pages/bp-my-reports/base-view-report.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for payslip
      {
        path: "/payslip",
        name: "payslip",
        component: () => import("../pages/bp-my-payslip/base-payslip.vue"),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "/viewpayslip/:uuid",
        name: "view-payslip",
        component: () => import("../pages/bp-my-payslip/base-view-payslip.vue"),
        meta: {
          requiresAuth: true
        }
      },
      //route for apply loan
      {
        path: "/applyloan",
        name: "applyloan",
        component: () => import("../pages/bp-apply-loan/base-apply-loan.vue"),
        meta: {
          requiresAuth: true
        }
      },
      // route for change password
      {
        path: "/settings",
        name: "settings",
        component: () =>
          import("../pages/bp-my-settings/base-settings-changepass.vue"),
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes/routes.js